<template>
  <CustomPage title="确认订单信息" :noBorder="true" style="background: #f7f7f7">
    <div slot="content" class="px-3">
      <div class="settle-container mb-2"></div>
      <div class="amount-panel-container flex flex-col items-center">
        <img src="@/assets/order/shouhuodizhi.svg" class="w-full flex-grow-0" alt />
        <div
          class="flex-grow w-full p-3 bg-white lightshadow rounded flex items-center"
          @click="
            () =>
            {
              if (!ordered) $router.push({ name: 'SettleAddressList' });
            }
          "
        >
          <img src="@/assets/order/地址.svg" />
          <div v-if="selectedAddress.name" class="mx-3 flex-grow">
            <div class="font-semibold">{{ selectedAddress.name }}&nbsp;{{ selectedAddress.phone }}</div>
            <div class="text-sm" style="color: #999999">
              {{
                areaList.province_list[selectedAddress.province] +
                  " " +
                  areaList.city_list[selectedAddress.city] +
                  " " +
                  areaList.county_list[selectedAddress.area] +
                  " " +
                  selectedAddress.address
              }}
            </div>
          </div>
          <div v-else class="mx-3 flex-grow">
            <div class="text-sm" style="color: #999999">请选择地址</div>
          </div>

          <Icon name="arrow" />
        </div>
      </div>
      <div v-for="orderGroup in shoppingDetail.orderGroups" :key="orderGroup.actId">
        <div
          class="rounded-tl-lg bg-white py-2 border-l-8 border-red-600 lightshadow my-2 px-2 font-semibold text-xs mt-4"
        >{{ orderGroup.actName }}</div>

        <div
          v-for="order in orderGroup.orders"
          :key="order.signBrandId"
          class="lightshadow rounded bg-white p-2 mb-2"
        >
          <div class="flex justify-between mb-1">
            <span class="text-xs">{{ order.brandName }}</span>
            <img
              src="@/assets/order/票.svg"
              @click="
                () =>
                {
                  if (!ordered && invoiceState)
                  {
                    InvoicingActId = orderGroup.actId;
                    InvoicingSignBrandId = order.signBrandId;
                    $router.push({
                      name: 'NeedInvoice',
                      params: {
                        needInvoice: order.needInvoice,
                        useDependenceInvoiceAddress:
                          order.useDependenceInvoiceAddress,
                        name: order.name,
                        customerInvoiceId: order.customerInvoiceId,
                      },
                    });
                  }
                }
              "
            />
          </div>
          <div class="goodsitem flex flex-col">
            <div v-for="item in order.items" :key="item.actSkuId" class="flex my-1">
              <div
                style="height: 60px; width: 60px"
                class="flex-shrink-0 mr-2 rounded overflow-hidden"
              >
                <img class="h-full w-full" :src="item.goodsInfoImg" />
              </div>
              <div class="text-xs flex-grow">
                <div>{{ item.goodsInfoName }}</div>
                <div class="bg-f8 inline-block">{{ item.spec }}</div>
                <div class="flex justify-between items-center">
                  <div class="font-bold text-red">
                    <span>¥</span>
                    <span class="text-lg">{{ item.dealPrice }}</span>
                  </div>
                  <span style="color: #aeaeae">x{{ item.qty }}</span>
                </div>
              </div>
            </div>
            <Field
              class="bg-f8 text-xs p-1 my-1"
              style="color: #aeaeae"
              v-model="order.buyerRemarks"
              label-align="right"
              label-width="45px"
              label="备注："
            />
          </div>
          <CellGroup>
            <Cell title="配送方式" :value="'快递 ' + (order.freight ? order.freight + '元' : '免邮')"></Cell>
            <Cell v-show="order.needInvoice" title="开票金额" :value="'¥' + order.tax"></Cell>
          </CellGroup>
        </div>
        <div class="lightshadow rounded bg-white p-2 mt-2">
          <CellGroup>
            <Cell v-if="orderGroup.fullOff">
              <template #title>
                <span class="mr-2">满折</span>
                <span
                  class="text-xxs text-red border-red1px rounded px-1 mr-1"
                >{{ orderGroup.fullOff.discountRatio * 10 }}折</span>
              </template>
              <template #default>
                <span class="text-red">-¥{{ orderGroup.fullOff.discountAmount }}</span>
              </template>
            </Cell>
            <Cell is-link @click="showCouponSelect('act', orderGroup)">
              <template #title>
                <span>优惠券</span>
              </template>
              <template #default>
                <span v-if="orderGroup.availableCoupons" class="text-red">
                  -¥{{
                    orderGroup.availableCoupons
                      .map((actcp) =>
                        orderGroup.checkedCouponId &&
                          actcp.couponId === orderGroup.checkedCouponId
                          ? actcp.faceValue
                          : ""
                      )
                      .join("") || 0
                  }}
                </span>
              </template>
              <template #right-icon>
                <Icon name="arrow" color="#E82035" style="font-size: 16px; line-height: inherit" />
              </template>
            </Cell>
            <Cell is-link @click="showRedpackSelect('act', orderGroup)">
              <template #title>
                <span class="text-red">红包</span>
              </template>
              <template #default>
                <span v-if="orderGroup.availableRedPacks" class="text-red">
                  -¥{{
                    orderGroup.availableRedPacks
                      .map((actrp) =>
                        orderGroup.checkedRedPackId &&
                          actrp.rpId === orderGroup.checkedRedPackId
                          ? actrp.faceValue
                          : ""
                      )
                      .join("") || 0
                  }}
                </span>
              </template>
              <template #right-icon>
                <Icon name="arrow" color="#E82035" style="font-size: 16px; line-height: inherit" />
              </template>
            </Cell>
            <Cell
              v-show="
                orderGroup.activityReward &&
                (orderGroup.activityReward === 'AWARD' ||
                  $store.state.user.distributionFlag)
              "
            >
              <template #title>
                <span class="text-red">活动</span>
              </template>
              <template #default>
                <span class="text-red">
                  {{
                    new Object({ COMMISSION: "双倍佣金", AWARD: "抽奖", NEWBIE: "新人" })[orderGroup.activityReward]
                  }}
                </span>
              </template>
            </Cell>
            <Cell :title="'共' + (orderGroup.totalQty || 0) + '件'" value="内容">
              <template #default>
                <span>小计</span>
                <span class="font-bold text-red">
                  ¥{{
                    (
                      orderGroup.postDiscountAmount +
                      orderGroup.freightTotal +
                      computax(orderGroup)
                    ).toFixed(2)
                  }}
                </span>
              </template>
            </Cell>
          </CellGroup>
        </div>
      </div>
      <div class="lightshadow rounded bg-white p-2 mt-6 mb-20">
        <CellGroup>
          <Cell
            v-if="
              !$store.state.user.distributionFlag &&
              shoppingDetail.availableDistRedPacks.length
            "
            is-link
            @click="
              showRedpackSelect('dist', shoppingDetail.availableDistRedPacks)
            "
          >
            <template #title>
              <span>分销红包</span>
            </template>
            <template #default>
              <span class="text-red">-¥{{ checkedDistRedpackValue }}</span>
            </template>
            <template #right-icon>
              <Icon name="arrow" color="#E82035" style="font-size: 16px; line-height: inherit" />
            </template>
          </Cell>
          <Cell
            is-link
            @click="
              showRedpackSelect(
                'platform',
                shoppingDetail.availablePlatFormRedPacks
              )
            "
          >
            <template #title>
              <span>平台红包</span>
            </template>
            <template #default>
              <span class="text-red">-¥{{ checkedPlatformRedpackValue }}</span>
            </template>
            <template #right-icon>
              <Icon name="arrow" color="#E82035" style="font-size: 16px; line-height: inherit" />
            </template>
          </Cell>
          <Cell
            is-link
            @click="
              showCouponSelect('platform', shoppingDetail.availableCoupons)
            "
          >
            <template #title>
              <span>平台优惠券</span>
            </template>
            <template #default>
              <span class="text-red">-¥{{ checkedPlatformCouponValue }}</span>
            </template>
            <template #right-icon>
              <Icon name="arrow" color="#E82035" style="font-size: 16px; line-height: inherit" />
            </template>
          </Cell>
        </CellGroup>
      </div>
      <ActionSheet v-model="showCoupon" title="优惠券">
        <div class="m-3 overflow-y-auto" style="max-height: 21rem">
          <div
            v-for="item in couponList"
            :key="item.id"
            class="rounded-md border flex flex-row text-white mb-3 items-center justify-between pr-3"
            :style="{
              borderColor: item.checkable ? '#E89A52' : '#CECECE',
            }"
          >
            <div
              class="w-40 flex flex-col justify-center items-center p-3"
              :style="{
                background: item.checkable
                  ? 'linear-gradient(90deg, #FBC787 0%, #E79950 100%)'
                  : '#CECECE',
              }"
            >
              <div>
                <span class="text-xl">¥&nbsp;</span>
                <span
                  class="leading-10 font-semibold"
                  style="letter-spacing: 0.1rem; font-size: 2.5rem"
                >{{ item.faceValue }}</span>
              </div>
              <div class="text-xs">
                满{{
                  item.ref.coupon.threshold
                    ? item.ref.coupon.threshold
                    : "任意"
                }}元可用
              </div>
            </div>
            <div class="text-left flex-grow ml-3">
              <div class="text-black text-sm mb-1">{{ item.ref.coupon.couponName }}</div>
              <div
                class="text-xs text-gray"
              >{{ item.ref.coupon.startDate }} - {{ item.ref.coupon.endDate }}</div>
            </div>
            <div>
              <Button
                :disabled="!item.checkable"
                class="w-20"
                style="padding-left: 12px; padding-right: 12px"
                round
                :color="item.checkable ? '#E89A52' : '#CECECE'"
                size="mini"
                @click="useCoupon(item)"
              >{{ item.checkable ? "使用" : "不可用" }}</Button>
            </div>
          </div>
          <div v-show="!couponList.length" class="text-center pt-1 pb-2 text-gray">没有可用优惠券</div>
        </div>
        <div class="mx-3 mb-3">
          <Button
            style="padding-left: 12px; padding-right: 12px"
            round
            color="linear-gradient(135deg, #E82237 0%, #FF9D9D 100%)"
            size="large"
            @click="showCoupon = false"
          >完成</Button>
        </div>
      </ActionSheet>
      <ActionSheet v-model="showRedpack" title="红包">
        <div class="m-3 overflow-y-auto" style="max-height: 21rem">
          <div
            v-for="item in redpackList"
            :key="item.id"
            class="rounded-md border flex flex-row text-white mb-3 items-center justify-between pr-3"
            :style="{
              borderColor: item.checkable ? '#E82035' : '#CECECE',
            }"
          >
            <div
              class="w-40 flex flex-col justify-center items-center p-3"
              :style="{
                background: item.checkable
                  ? 'linear-gradient(90deg, #FB8787 0%, #E75050 100%)'
                  : '#CECECE',
              }"
            >
              <div>
                <span class="text-xl">¥&nbsp;</span>
                <span
                  class="leading-10 font-semibold"
                  style="letter-spacing: 0.1rem; font-size: 2.5rem"
                >{{ item.faceValue }}</span>
              </div>
              <div class="text-xs">
                {{
                  item.scope === "DISTRIBUTION"
                    ? "满" + item.ref.fullAmount + "元可用"
                    : "无门槛"
                }}
              </div>
            </div>
            <div class="text-left flex-grow ml-3">
              <div class="text-black text-sm mb-1">
                {{
                  item.scope === "DISTRIBUTION"
                    ? item.ref.storeRedPacket.title
                    : item.ref.redPacket.redPacketName
                }}
              </div>
              <div class="text-xs text-gray">
                {{
                  item.scope === "DISTRIBUTION"
                    ? item.ref.storeRedPacket.startDate +
                    " - " +
                    item.ref.storeRedPacket.endDate
                    : item.ref.redPacket.startDate +
                    " - " +
                    item.ref.redPacket.endDate
                }}
              </div>
            </div>
            <div>
              <Button
                :disabled="!item.checkable"
                class="w-20"
                style="padding-left: 12px; padding-right: 12px"
                round
                :color="item.checkable ? '#E82035' : '#CECECE'"
                size="mini"
                @click="useRedpack(item)"
              >{{ item.checkable ? "使用" : "不可用" }}</Button>
            </div>
          </div>
          <div v-show="!redpackList.length" class="text-center pt-1 pb-2 text-gray">没有可用红包</div>
        </div>
        <div class="mx-3 mb-3">
          <Button
            style="padding-left: 12px; padding-right: 12px"
            round
            color="linear-gradient(135deg, #E82237 0%, #FF9D9D 100%)"
            size="large"
            @click="showRedpack = false"
          >完成</Button>
        </div>
      </ActionSheet>
      <ActionSheet v-model="showPayment" title="选择付款方式" class="font-semibold text-sm">
        <div v-if="paymentChannelList.length" class="content px-5">
          <div class="flex justify-between items-center my-3" @click="goPay(paymentChannelList[0])">
            <div class="flex items-center">
              <img class="mr-2" src="@/assets/order/余额.svg" alt />
              <span>
                {{
                  paymentChannelList[0].name
                }}
              </span>
            </div>
            <div>{{ paymentChannelList[0].withdrawAmount + "元" }}</div>
          </div>
          <div style="color: #808080">第三方支付</div>
          <!-- MARK: -->
          <div
            v-show="totalAmount > 0"
            v-for="(channel, index) in paymentChannelList"
            :key="channel.code"
            class="flex justify-between items-center my-3"
            @click="goPay(channel)"
          >
            <div v-if="index" class="flex items-center">
              <img v-if="channel.code === 'ALI'" class="mr-2" src="@/assets/order/支付宝.svg" alt />
              <img v-else-if="channel.code === 'WX'" class="mr-2" src="@/assets/order/微信钱包.svg" alt />
              <img v-else class="mr-2" :src="channel.logo" alt />
              <span>
                {{
                  channel.name
                }}
              </span>
            </div>
            <div></div>
          </div>
          <div v-show="totalAmount <= 0" class="font-normal py-2">无需第三方支付</div>
        </div>
      </ActionSheet>
      <ActionSheet v-model="showPasswordInput" title="请输入支付密码" class="text-sm pb-64">
        <div class="w-full text-center">余额支付</div>
        <div class="w-full text-center text-3xl">￥{{ payAmount }}</div>
        <PasswordInput
          :value="password"
          :focused="showPasswordInput"
          @focus="showPasswordInput = true"
        />
        <!-- 数字键盘 -->
        <NumberKeyboard
          v-model="password"
          :show="showPasswordInput"
          @blur="showPasswordInput = false"
        />
      </ActionSheet>
      <!-- 去支付 -->
      <SubmitBar
        v-show="showSubmitBar && !showPayConfirm"
        button-text="去支付"
        button-color="linear-gradient(135deg, #E82237 0%, #FF9D9D 100%)"
        label
        @submit="onSubmit"
      >
        <template #default>
          <div class="text-right mr-2">
            <div>
              <span class="text-xxs" style="color: #808080">共{{ totalGoodsNum }}件</span>
              <span class="text-sm ml-2">合计：</span>
              <span class="text-base font-bold text-red">¥{{ totalAmount.toFixed(2) }}</span>
            </div>
            <div
              v-show="shoppingDetail.aggregateDiscount"
              class="text-xxs"
            >已节省{{ shoppingDetail.aggregateDiscount }}元</div>
          </div>
        </template>
      </SubmitBar>
      <Overlay :show="showPayConfirm">
        <div class="wrapper">
          <div class="block text-center flex flex-col justify-evenly rounded-lg">
            <div class="px-3">请确认支付是否完成</div>
            <hr />
            <div
              @click="
                $router.replace({
                  path: '/mine/order',
                  query: { active: 2, backRoute: 'Mine' },
                })
              "
              class="text-red text-lg px-3"
            >我已完成支付</div>
            <hr />
            <div
              class="px-3"
              @click="
                $router.replace({
                  path: '/mine/order',
                  query: { active: 1, backRoute: 'Mine' },
                })
              "
            >支付遇到问题</div>
          </div>
        </div>
      </Overlay>
      <CustomView />
    </div>
  </CustomPage>
</template>

<script>
import CustomPage from "@/components/custom-page";
import CustomView from "@/components/custom-view";
import { getToken } from "@/utils/auth";
import
{
  shoppingDetail,
  purchaseDirect,
  purchaseSuiteDirect,
  purchaseAwardDirect,
  purchaseFreeGoodsDirect,
  calcOrder,
  calcSuiteOrder,
  calcAwardOrder,
  calcFreeGoodsOrder,
  submitOrder,
  submitSuiteOrder,
  submitAwardOrder,
  submitFreeGoodsOrder,
} from "./webApi";
import
{
  getPayChannels,
  orderPay,
  getBillInfo,
  payByBalance,
  payByWxH5,
  payByWxJsapi,
  payByAliH5,
  payPasswordExists,
} from "@/api/pay.js";
import { getCustomerInvoice } from "@/api/setting/invoice";
import { getAppId } from "@/api/login";
import browserType from "@/utils/browserType";
import browserTypeAdapter from "@/utils/browserTypeAdapter";
import { getAddressList } from "@/api/setting/address.js";
import { areaList } from "@vant/area-data";
import { getWechatSign } from "@/api/login";
import
{
  Icon,
  Field,
  Cell,
  CellGroup,
  SubmitBar,
  ActionSheet,
  Button,
  Toast,
  PasswordInput,
  NumberKeyboard,
  Overlay,
} from "vant";

export default {
  components: {
    CustomPage,
    CustomView,
    Icon,
    Field,
    Cell,
    CellGroup,
    SubmitBar,
    ActionSheet,
    Button,
    PasswordInput,
    NumberKeyboard,
    Overlay,
  },
  created()
  {
    this.$store.dispatch("app/showLoading");
    if (this.$route.query.fromWx || this.$route.query.fromAli)
    {
      this.$store.dispatch("app/hideLoading");
      this.showPayConfirm = true;
    } else
    {
      if (this.$route.query.code)
      {
        const _this = this;
        payByWxJsapi({
          billId: this.$route.query.billId,
          code: this.$route.query.code,
        })
          .then((res) =>
          {
            // res.data是{appid:...,timestamp:...}
            this.wxPaymentParams = res.data;
            function onBridgeReady()
            {
              WeixinJSBridge.invoke(
                "getBrandWCPayRequest",
                res.data,
                function (res)
                {
                  _this.$store.dispatch("app/hideLoading");
                  if (res.err_msg == "get_brand_wcpay_request:ok")
                  {
                    // 使用以上方式判断前端返回,微信团队郑重提示：
                    //res.err_msg将在用户支付成功后返回ok，但并不保证它绝对可靠。
                    Toast({
                      message: "支付完成",
                      position: "center",
                      duration: 1000,
                    });
                    _this.$router.replace({
                      path: "/mine/order",
                      query: { active: 2, backRoute: "Mine" },
                    });
                  } else
                  {
                    Toast({
                      message: "支付失败",
                      position: "center",
                      duration: 1000,
                    });
                    _this.$router.replace({
                      path: "/mine/order",
                      query: { active: 1, backRoute: "Mine" },
                    });
                  }
                }
              );
            }
            if (typeof WeixinJSBridge == "undefined")
            {
              if (document.addEventListener)
              {
                document.addEventListener(
                  "WeixinJSBridgeReady",
                  onBridgeReady,
                  false
                );
              } else if (document.attachEvent)
              {
                document.attachEvent("WeixinJSBridgeReady", onBridgeReady);
                document.attachEvent("onWeixinJSBridgeReady", onBridgeReady);
              }
            } else
            {
              onBridgeReady();
            }
          })
          .catch((e) =>
          {
            this.$store.dispatch("app/hideLoading");
          });
      } else
      {
        getAddressList(this.$store.state.user.customerId).then(
          (addressRes) =>
          {
            this.updateAddress(addressRes);
            getCustomerInvoice(this.$store.state.user.customerId).then(
              (res) =>
              {
                if (res.data?.checkState === 1)
                {
                  this.invoiceState = true;
                }
              }
            );
            if (this.$route.params.subData)
            {
              if (this.$route.params.subData.suiteId)
              {
                this.calcType = "suite";
                this.suiteId = this.$route.params.subData.suiteId;
                purchaseSuiteDirect(this.$route.params.subData)
                  .then(({ data }) =>
                  {
                    this.fid = data.fid;
                    data.orderGroups.map((orderGroup) =>
                    {
                      orderGroup.orders.forEach((order) =>
                      {
                        order.needInvoice = false;
                        order.customerInvoiceId = null;
                        order.invoiceAddress = this.curAddressName;
                      });
                    });
                    this.shoppingDetail = data;
                    this.$store.dispatch("app/hideLoading");
                  })
                  .catch((e) =>
                  {
                    this.$store.dispatch("app/hideLoading");
                  });
              } else
              {
                purchaseDirect(this.$route.params.subData)
                  .then(({ data }) =>
                  {
                    this.fid = data.fid;
                    data.orderGroups.map((orderGroup) =>
                    {
                      orderGroup.orders.forEach((order) =>
                      {
                        order.needInvoice = false;
                        order.customerInvoiceId = null;
                        order.invoiceAddress = this.curAddressName;
                      });
                    });
                    this.shoppingDetail = data;
                    this.$store.dispatch("app/hideLoading");
                  })
                  .catch((e) =>
                  {
                    this.$store.dispatch("app/hideLoading");
                  });
              }
            } else if (this.$route.query.awardId)
            {
              this.calcType = "award";
              this.awardId = this.$route.query.awardId;
              purchaseAwardDirect({ awardId: this.$route.query.awardId })
                .then(({ data }) =>
                {
                  this.fid = data.fid;
                  data.orderGroups.map((orderGroup) =>
                  {
                    orderGroup.orders.forEach((order) =>
                    {
                      order.needInvoice = false;
                      order.customerInvoiceId = null;
                      order.invoiceAddress = this.curAddressName;
                    });
                  });
                  this.shoppingDetail = data;
                  this.$store.dispatch("app/hideLoading");
                })
                .catch((e) =>
                {
                  this.$store.dispatch("app/hideLoading");
                });
            } else if (this.$route.query.taskId)
            {
              this.calcType = "task";
              this.taskId = this.$route.query.taskId;
              purchaseFreeGoodsDirect({ taskId: this.$route.query.taskId })
                .then(({ data }) =>
                {
                  this.fid = data.fid;
                  data.orderGroups.map((orderGroup) =>
                  {
                    orderGroup.orders.forEach((order) =>
                    {
                      order.needInvoice = false;
                      order.customerInvoiceId = null;
                      order.invoiceAddress = this.curAddressName;
                    });
                  });
                  this.shoppingDetail = data;
                  this.$store.dispatch("app/hideLoading");
                })
                .catch((e) =>
                {
                  this.$store.dispatch("app/hideLoading");
                });
            } else if (this.$route.params.fid)
            {
              this.fid = this.$route.params.fid;
              shoppingDetail({ fid: this.fid })
                .then(({ data }) =>
                {
                  data.orderGroups.map((orderGroup) =>
                  {
                    orderGroup.orders.forEach((order) =>
                    {
                      order.needInvoice = false;
                      order.customerInvoiceId = null;
                      order.invoiceAddress = this.curAddressName;
                    });
                  });
                  this.shoppingDetail = data;

                  this.$store.dispatch("app/hideLoading");
                })
                .catch((e) =>
                {
                  this.$store.dispatch("app/hideLoading");

                  this.$router.replace({
                    path: "/mine/order",
                    query: { backRoute: "Mine" },
                  });
                });
            }
          }
        );
      }
    }
  },
  data()
  {
    return {
      wxPaymentParams: {},
      browserTypeStr: null,
      areaList,
      addressList: [],
      selectedAddress: {},
      invoiceState: false,
      fid: null,
      shoppingDetail: {
        availableCoupons: [],
        availableDistRedPacks: [],
        availablePlatFormRedPacks: [],
        orderGroups: [{ orders: [] }],
      },
      showSubmitBar: true,
      showCoupon: false,
      showRedpack: false,
      showPayment: false,
      paymentChannelList: [],
      selectingCouponType: null,
      selectingRedpackType: null,
      couponList: [],
      redpackList: [],
      editingRedpackItem: null,
      editingCouponItem: null,
      curAddressId: null,
      curAddressName: null,
      currentAddress: null,
      InvoicingActId: null,
      InvoicingSignBrandId: null,
      shoppingId: null,
      ordered: false,
      billId: null,
      payAmount: 0,
      showPasswordInput: false,
      password: "",
      showPayConfirm: false,
      payPasswordExist: false,
      calcType: "",
      suiteId: null,
    };
  },
  methods: {
    filterPaymentChannel()
    {
      // 可以在这里将 paymentChannelList 做一个拦截 如果browserTypeStr 是 miniprogram 的话 就将支付宝剔除掉
      if (this.browserTypeStr === "miniprogram")
      {
        this.paymentChannelList = this.paymentChannelList.filter(
          (paymentChannel) =>
          {
            return !(paymentChannel.code === "ALI");
          }
        );
      }
    },
    updateAddress(addressRes)
    {
      this.addressList = addressRes.data.map((item) =>
      {
        const province = this.areaList.province_list[item.province];
        const city = this.areaList.city_list[item.city];
        const county = this.areaList.county_list[item.area];
        item.areaName = `${province} ${city} ${county} ${item.address}`;
        if (item.defaultFlag)
        {
          this.selectedAddress = item;
          this.curAddressId = item.id;
          this.curAddressName = item.areaName;
          this.$store.commit("settle/CHANGE_DELIVER_ADDRESS", item.id);
        }

        return item;
      });
    },
    showCouponSelect(type, item)
    {

      console.log("type", type);
      this.selectingCouponType = type;
      if (type === "platform")
      {
        this.couponList = item;
      } else
      {
        this.couponList = item.availableCoupons;
        this.editingCouponItem = item;
      }

      this.showCoupon = true;
    },
    showRedpackSelect(type, item)
    {

      console.log("type", type);
      this.selectingRedpackType = type;
      if (type === "platform" || type === "dist")
      {
        this.redpackList = item;
      } else
      {
        this.redpackList = item.availableRedPacks;
        this.editingRedpackItem = item;
      }

      this.showRedpack = true;
    },
    useCoupon(item)
    {


      console.log("item", item);
      console.log("editingCouponItem", this.editingCouponItem);
      let diff;
      switch (this.selectingCouponType)
      {
        case "platform":
          // this.shoppingDetail.checkedCouponId = item.couponId
          // break

          diff = this.checkedPlatformCouponValue - item.faceValue;

          this.shoppingDetail.checkedCouponId = item.couponId;
          //合计
          this.shoppingDetail.postDiscountAmount += diff;
          this.shoppingDetail.actualPayAmount += diff;

          //已结省

          this.shoppingDetail.aggregateDiscount =
            (this.shoppingDetail.aggregateDiscount * 100 - diff * 100) / 100;

          this.showCoupon = false;
          break;

        default:
          // if (this.editingCouponItem.checkedCouponId !== item.couponId) {
          //   this.editingCouponItem.checkedCouponId = item.couponId
          // }

          if (this.editingCouponItem.checkedCouponId !== item.couponId)
          {
            this.editingCouponItem.availableCoupons.map((coupons) =>
            {
              if (
                this.editingCouponItem.checkedCouponId === coupons.couponId
              )
              {
                diff = coupons.faceValue - item.faceValue;
                return;
              }
            });
            this.editingCouponItem.postDiscountAmount += diff;
            this.editingCouponItem.postApportionAmount += diff;
            this.editingCouponItem.actualPayAmount += diff;
            this.editingCouponItem.actDiscountTotal -= diff;
            this.editingCouponItem.checkedCouponId = item.couponId;

            this.shoppingDetail.postDiscountAmount += diff;
            this.shoppingDetail.actualPayAmount += diff;
            this.shoppingDetail.aggregateDiscount =
              (this.shoppingDetail.aggregateDiscount * 100 - diff * 100) /
              100;
            this.showCoupon = false;
          } else
          {
            this.showCoupon = false;
          }

          break;
      }
      // this.calcOrder()

      // console.log('item', item)
      // console.log('editingCouponItem', this.editingCouponItem)

      // if (
      //   this.editingCouponItem &&
      //   item.couponId !== this.editingCouponItem.checkedCouponId
      // ) {
      //   switch (this.selectingCouponType) {
      //     case 'platform':
      //       this.shoppingDetail.checkedCouponId = item.couponId
      //       break

      //     default:
      //       if (this.editingCouponItem.checkedCouponId !== item.couponId) {
      //         this.editingCouponItem.checkedCouponId = item.couponId
      //       }
      //       break
      //   }
      //   this.calcOrder()
      // }

      // this.showCoupon = false
    },
    useRedpack(item)
    {

      console.log("item", item);
      console.log("editingRedpackItem", this.editingRedpackItem);
      let diff;
      switch (this.selectingRedpackType)
      {
        case "platform":
          diff = this.checkedPlatformRedpackValue - item.faceValue;

          this.shoppingDetail.checkedPlatformRedPackId = item.rpId;
          //合计
          this.shoppingDetail.postDiscountAmount += diff;
          this.shoppingDetail.actualPayAmount += diff;

          //已结省
          this.shoppingDetail.aggregateDiscount =
            (this.shoppingDetail.aggregateDiscount * 100 - diff * 100) / 100;
          this.showRedpack = false;
          break;
        case "dist":
          diff = this.checkedDistRedpackValue - item.faceValue;

          this.shoppingDetail.checkedDistRedPackId = item.rpId;
          this.shoppingDetail.postDiscountAmount += diff;
          this.shoppingDetail.actualPayAmount += diff;
          this.shoppingDetail.aggregateDiscount =
            (this.shoppingDetail.aggregateDiscount * 100 - diff * 100) / 100;
          this.showRedpack = false;
          break;

        default:
          if (this.editingRedpackItem.checkedRedPackId !== item.rpId)
          {
            this.editingRedpackItem.availableRedPacks.map((redpack) =>
            {
              if (this.editingRedpackItem.checkedRedPackId === redpack.rpId)
              {
                diff = redpack.faceValue - item.faceValue;
                return;
              }
            });
            this.editingRedpackItem.postDiscountAmount += diff;
            this.editingRedpackItem.postApportionAmount += diff;
            this.editingRedpackItem.actualPayAmount += diff;
            this.editingRedpackItem.actDiscountTotal -= diff;
            this.editingRedpackItem.checkedRedPackId = item.rpId;

            this.shoppingDetail.postDiscountAmount += diff;
            this.shoppingDetail.actualPayAmount += diff;
            this.shoppingDetail.aggregateDiscount =
              (this.shoppingDetail.aggregateDiscount * 100 - diff * 100) /
              100;
            this.showRedpack = false;
          } else
          {
            this.showRedpack = false;
          }

          break;
      }
    },
    computax(orderGroup)
    {
      let tax = 0;
      orderGroup.orders.map((order) =>
      {
        if (order.needInvoice)
        {
          tax += order.tax;
        }
      });
      return tax;
    },
    calcOrder()
    {
      let order = {
        orderGroups: this.shoppingDetail.orderGroups.map((orderGroup) =>
        {
          return {
            actId: orderGroup.actId,
            actName: orderGroup.actName,
            orders: orderGroup.orders.map((order) =>
            {
              return {
                remark: order.buyerRemarks,
                partId: order.partAct.partId,
                needInvoice: order.needInvoice,
                brandName: order.brandName,
                customerInvoiceId: order.customerInvoiceId,
                invoiceAddress: order.invoiceAddress,
              };
            }),
            checkedRedPack: orderGroup.checkedRedPackId,
            checkedCoupon: orderGroup.checkedCouponId,
          };
        }),
        fid: this.fid,
        checkedPlatformCoupon: this.shoppingDetail.checkedCouponId,
        checkedDistributionRedPack: this.shoppingDetail.checkedDistRedPackId,
        shippingAddressId: this.currentAddress
          ? this.currentAddress
          : this.$store.state.settle.currentAddress,
        checkedPlatformRedPack: this.shoppingDetail.checkedPlatformRedPackId,
      };
      this.$store.dispatch("app/showLoading");
      if (this.calcType === "suite")
      {
        order.suiteId = this.suiteId;
        calcSuiteOrder(order)
          .then(({ data }) =>
          {
            this.shoppingDetail = data;
            this.curAddressId = this.currentAddress
              ? this.currentAddress
              : this.$store.state.settle.currentAddress;
            this.addressList.map((item) =>
            {
              if (this.curAddressId === item.id)
              {
                this.selectedAddress = item;
                return;
              }
            });
            this.$store.dispatch("app/hideLoading");
          })
          .catch((e) =>
          {
            this.$store.dispatch("app/hideLoading");
          });
      } else if (this.calcType === "award")
      {
        order.awardId = this.awardId;
        calcAwardOrder({
          awardId: this.awardId,
          shippingAddressId: order.shippingAddressId,
        })
          .then(({ data }) =>
          {
            this.shoppingDetail = data;
            this.curAddressId = this.currentAddress
              ? this.currentAddress
              : this.$store.state.settle.currentAddress;
            this.addressList.map((item) =>
            {
              if (this.curAddressId === item.id)
              {
                this.selectedAddress = item;
                return;
              }
            });
            this.$store.dispatch("app/hideLoading");
          })
          .catch((e) =>
          {
            this.$store.dispatch("app/hideLoading");
          });
      } else if (this.calcType === "task")
      {
        order.taskId = this.taskId;
        calcFreeGoodsOrder({
          taskId: this.taskId,
          shippingAddressId: order.shippingAddressId,
        })
          .then(({ data }) =>
          {
            this.shoppingDetail = data;
            this.curAddressId = this.currentAddress
              ? this.currentAddress
              : this.$store.state.settle.currentAddress;
            this.addressList.map((item) =>
            {
              if (this.curAddressId === item.id)
              {
                this.selectedAddress = item;
                return;
              }
            });
            this.$store.dispatch("app/hideLoading");
          })
          .catch((e) =>
          {
            this.$store.dispatch("app/hideLoading");
          });
      } else
      {
        calcOrder(order)
          .then(({ data }) =>
          {
            this.shoppingDetail = data;
            this.curAddressId = this.currentAddress
              ? this.currentAddress
              : this.$store.state.settle.currentAddress;
            this.addressList.map((item) =>
            {
              if (this.curAddressId === item.id)
              {
                this.selectedAddress = item;
                return;
              }
            });
            this.$store.dispatch("app/hideLoading");
          })
          .catch((e) =>
          {
            this.$store.dispatch("app/hideLoading");
          });
      }
    },
    // MARK:
    async onSubmit()
    {

      await this.getpayPasswordExists();
      if (!this.selectedAddress?.name)
      {
        Toast({
          message: "请选择地址",
          position: "center",
          duration: 1000,
        });
        return;
      }
      if (this.shoppingId && this.paymentChannelList.length)
      {
        this.showPayment = true;
        return;
      }
      this.$store.dispatch("app/showLoading");
      // this.browserTypeStr = localStorage.getItem('browserType') || browserType()
      this.browserTypeStr =
        localStorage.getItem("browserTypeAdapter") || browserTypeAdapter();
      // MARK:
      console.log("browserTypeAdapter");
      console.log(this.browserTypeStr);
      let order = {
        orderGroups: this.shoppingDetail.orderGroups.map((orderGroup) =>
        {
          return {
            actId: orderGroup.actId,
            actName: orderGroup.actName,
            orders: orderGroup.orders.map((order) =>
            {
              return {
                remark: order.buyerRemarks,
                partId: order.partAct.partId,
                needInvoice: order.needInvoice,
                brandName: order.brandName,
                customerInvoiceId: order.customerInvoiceId,
                invoiceAddress: order.invoiceAddress,
              };
            }),
            checkedRedPack: orderGroup.checkedRedPackId,
            checkedCoupon: orderGroup.checkedCouponId,
          };
        }),
        fid: this.fid,
        checkedPlatformCoupon: this.shoppingDetail.checkedCouponId,
        checkedDistributionRedPack: this.shoppingDetail.checkedDistRedPackId,
        shippingAddressId: this.currentAddress
          ? this.currentAddress
          : this.$store.state.settle.currentAddress,
        shippingAddress: this.selectedAddress.areaName,
        checkedPlatformRedPack: this.shoppingDetail.checkedPlatformRedPackId,
      };
      if (this.calcType === "suite")
      {
        order.suiteId = this.suiteId;
        submitSuiteOrder(order)
          .then((res) =>
          {
            this.ordered = true;
            this.shoppingId = res.data;
            getPayChannels({ targetId: this.shoppingId })
              .then(({ data }) =>
              {
                this.paymentChannelList = data;
                this.filterPaymentChannel();
                this.showPayment = true;
                this.$store.dispatch("app/hideLoading");
              })
              .catch((e) =>
              {
                this.$store.dispatch("app/hideLoading");
              });
          })
          .catch((e) =>
          {
            this.$store.dispatch("app/hideLoading");
          });
      } else if (this.calcType === "award")
      {
        order.awardId = this.awardId;
        submitAwardOrder({
          awardId: this.awardId,
          shippingAddressId: order.shippingAddressId,
        })
          .then((res) =>
          {
            this.ordered = true;
            this.shoppingId = res.data;
            getPayChannels({ targetId: this.shoppingId })
              .then(({ data }) =>
              {
                this.paymentChannelList = data;
                this.filterPaymentChannel();
                this.showPayment = true;
                this.$store.dispatch("app/hideLoading");
              })
              .catch((e) =>
              {
                this.$store.dispatch("app/hideLoading");
              });
          })
          .catch((e) =>
          {
            this.$store.dispatch("app/hideLoading");
          });
      } else if (this.calcType === "task")
      {
        order.taskId = this.taskId;
        submitFreeGoodsOrder({
          taskId: this.taskId,
          shippingAddressId: order.shippingAddressId,
        })
          .then((res) =>
          {
            this.ordered = true;
            this.shoppingId = res.data;
            getPayChannels({ targetId: this.shoppingId })
              .then(({ data }) =>
              {
                this.paymentChannelList = data;
                this.filterPaymentChannel();
                this.showPayment = true;
                this.$store.dispatch("app/hideLoading");
              })
              .catch((e) =>
              {
                this.$store.dispatch("app/hideLoading");
              });
          })
          .catch((e) =>
          {
            this.$store.dispatch("app/hideLoading");
          });
      } else
      {
        submitOrder(order)
          .then((res) =>
          {
            this.ordered = true;
            this.shoppingId = res.data;
            getPayChannels({ targetId: this.shoppingId })
              .then(({ data }) =>
              {
                this.paymentChannelList = data;
                this.filterPaymentChannel();
                this.showPayment = true;
                this.$store.dispatch("app/hideLoading");
              })
              .catch((e) =>
              {
                this.$store.dispatch("app/hideLoading");
              });
          })
          .catch((e) =>
          {
            this.$store.dispatch("app/hideLoading");
          });
      }
    },
    // 设置支付密码
    settleSafePayPwd()
    {
      Toast({
        message: "未设置支付密码",
        position: "center",
        duration: 1000,
      });
      this.showPayment = false;
      this.$router.push({ name: "SettleSafePayPwd" });
    },
    // 获取是否有支付密码
    getpayPasswordExists()
    {
      return new Promise((resolve, reject) =>
      {
        payPasswordExists()
          .then((res) =>
          {
            console.log(res, "dsadas");
            this.$store.dispatch("app/hideLoading");
            if (res.data)
            {
              this.payPasswordExist = true;
            } else
            {
              this.payPasswordExist = false;
            }
            resolve();
          })
          .catch(() =>
          {
            this.$store.dispatch("app/hideLoading");
            reject();
          });
      });
    },
    goPay(channel)
    {
      if (
        channel.code === "BALANCE" &&
        channel.withdrawAmount < this.totalAmount
      )
      {
        return Toast({
          message: "余额不足,请选择其他付款方式",
          position: "center",
          duration: 1000,
        });
      }
      if (this.billId && channel.code === "BALANCE")
      {
        if (this.payPasswordExist)
        {
          this.showPasswordInput = true;
        } else
        {
          this.settleSafePayPwd();
          // Toast({
          //   message: "未设置支付密码",
          //   position: "center",
          //   duration: 1000,
          // });
        }
        return;
      }
      if (channel.available)
      {
        this.showPayment = false;
        this.$store.dispatch("app/showLoading");
        orderPay({ targetId: this.shoppingId, channel: channel.code }).then(
          ({ data }) =>
          {
            this.billId = data;
            getBillInfo(this.billId)
              .then(({ data }) =>
              {

                console.log(data, "bill");

                this.payAmount = data.amount;
                const orderPayCompleteInfo = {
                  serialNo: data.id,
                  payAmount: data.amount,
                };
                localStorage.setItem(
                  "orderPayCompleteInfo",
                  JSON.stringify(orderPayCompleteInfo)
                );

                if (data.channel === "BALANCE")
                {
                  payPasswordExists().then(({ data }) =>
                  {
                    if (data)
                    {
                      this.showPasswordInput = true;
                      this.payPasswordExist = true;
                    } else
                    {
                      this.settleSafePayPwd();
                      // Toast({
                      //   message: "未设置支付密码",
                      //   position: "center",
                      //   duration: 1000,
                      // });
                    }
                  });
                } else if (data.channel === "WX")
                {
                  // wx start
                  this.$store.dispatch("app/showLoading");

                  if (this.browserTypeStr === "pc")
                  {
                    console.log("pc");
                    // getAppId()
                    //   .then((res) => {
                    //     this.wechatAuth(res.data);
                    //   })
                    //   .catch(() => {
                    this.$store.dispatch("app/hideLoading");
                    //   });
                  } else if (this.browserTypeStr === "miniprogram")
                  {
                    const token = getToken();
                    const Authorization = "Bearer " + token;
                    // MARK:
                    // 当前环境是 小程序
                    console.log("miniprogram");
                    // 然后使用 this.wxjs.miniProgram.navigateTo 进行跳转 小程序中的页面
                    //小程序的支付地址
                    console.log(this.wxjs.miniProgram);
                    this.wxjs.miniProgram.navigateTo({
                      url: `../wxpay/wxpay?billId=${this.billId}&Authorization=${Authorization}`,
                      success: function (res)
                      {
                        console.log("res success 跳转小程序成功", res);
                      },
                      fail: function (res)
                      {
                        console.log("res fail 跳转失败", res);
                      },
                    });
                  } else if (this.browserTypeStr === "weixin")
                  {
                    console.log("weixin");
                    getAppId()
                      .then((res) =>
                      {
                        this.wechatAuth(res.data);
                      })
                      .catch(() =>
                      {
                        this.$store.dispatch("app/hideLoading");
                      });
                  } else
                  {
                    console.log("mobile");
                    payByWxH5({ billId: this.billId })
                      .then((res) =>
                      {
                        let href =
                          res.data +
                          "&redirect_url=" +
                          encodeURIComponent(
                            window.location.origin +
                            this.$route.path +
                            "?fromWx=true"
                          );
                        // alert(href);
                        window.location.href = href;

                        this.$store.dispatch("app/hideLoading");
                      })
                      .catch((e) =>
                      {
                        this.$store.dispatch("app/hideLoading");
                      });
                  }
                  // wx end
                } else if (data.channel === "ALI")
                {
                  this.$store.dispatch("app/showLoading");

                  if (this.browserTypeStr === "pc")
                  {
                    console.log("pc");
                  } else if (this.browserTypeStr === "weixin")
                  {
                    console.log("weixin");
                    payByAliH5({
                      billId: this.billId,
                      returnUrl:
                        window.location.origin +
                        this.$route.path +
                        "?fromAli=true",
                      quitUrl:
                        window.location.origin +
                        this.$route.path +
                        "?fromAli=true",
                    })
                      .then((res) =>
                      {
                        // alert(res.data);
                        var form = res.data;
                        const div = document.createElement("div");
                        div.innerHTML = form;
                        document.body.appendChild(div);
                        document.forms[0].acceptCharset = "utf-8";
                        var queryParam = "";
                        Array.prototype.slice
                          .call(
                            document.querySelectorAll("input[type=hidden]")
                          )
                          .forEach(function (ele)
                          {
                            queryParam +=
                              "&" +
                              ele.name +
                              "=" +
                              encodeURIComponent(ele.value);
                          });
                        var gotoUrl =
                          document
                            .querySelector("form")
                            .getAttribute("action") +
                          "&" +
                          queryParam;
                        _AP.pay(gotoUrl);

                        this.$store.dispatch("app/hideLoading");
                      })
                      .catch((e) =>
                      {
                        this.$store.dispatch("app/hideLoading");
                      });
                  } else
                  {
                    console.log("mobile");
                    payByAliH5({
                      billId: this.billId,
                      returnUrl:
                        window.location.origin +
                        this.$route.path +
                        "?fromAli=true",
                      quitUrl:
                        window.location.origin +
                        this.$route.path +
                        "?fromAli=true",
                    })
                      .then((res) =>
                      {
                        // alert(res.data);
                        const div = document.createElement("div");

                        div.innerHTML = res.data;
                        document.body.appendChild(div);
                        document.forms[0].submit();

                        this.$store.dispatch("app/hideLoading");
                      })
                      .catch((e) =>
                      {
                        this.$store.dispatch("app/hideLoading");
                      });
                  }
                }
                this.$store.dispatch("app/hideLoading");
              })
              .catch((e) =>
              {
                this.$store.dispatch("app/hideLoading");
              });
          }
        );
      } else
      {
        Toast({
          message: channel.reason,
          position: "center",
          duration: 1000,
        });
      }
    },
    wechatAuth(appId)
    {
      const href =
        window.location.origin +
        this.$route.path +
        "?" +
        this.filterCodeByParams(["billId=" + this.billId]);
      // alert(href);

      const redirect_uri = encodeURIComponent(href);
      window.location.href = `https://open.weixin.qq.com/connect/oauth2/authorize?appid=${appId}&redirect_uri=${redirect_uri}&response_type=code&scope=snsapi_userinfo#wechat_redirect`;
    },
    // 过滤掉 code 参数
    filterCodeByParams(queryList = [])
    {
      for (const key in this.$route.query)
      {
        if (Object.hasOwnProperty.call(this.$route.query, key))
        {
          if (key !== "code")
          {
            queryList.push(`${key}=${this.$route.query[key]}`);
          }
        }
      }
      return queryList.join("&");
    },
  },
  computed: {
    totalAmount()
    {
      return (
        this.shoppingDetail.postDiscountAmount +
        this.shoppingDetail.freightTotal +
        this.realTotalTax
      );
    },
    checkedPlatformCouponValue()
    {
      let temp = 0;
      this.shoppingDetail.availableCoupons?.map((item) =>
      {
        if (item.couponId === this.shoppingDetail.checkedCouponId)
        {
          temp = item.faceValue;
          return;
        }
      });
      return temp;
    },
    checkedPlatformRedpackValue()
    {
      let temp = 0;
      this.shoppingDetail.availablePlatFormRedPacks?.map((item) =>
      {
        if (item.rpId === this.shoppingDetail.checkedPlatformRedPackId)
        {
          temp = item.faceValue;
          return;
        }
      });
      return temp;
    },
    checkedDistRedpackValue()
    {
      let temp = 0;
      this.shoppingDetail.availableDistRedPacks?.map((item) =>
      {
        if (item.rpId === this.shoppingDetail.checkedDistRedPackId)
        {
          temp = item.faceValue;
          return;
        }
      });
      return temp;
    },
    totalGoodsNum()
    {
      let temp = 0;
      this.shoppingDetail.orderGroups?.map(
        (item) => (temp += item.totalQty || 0)
      );
      return temp;
    },
    realTotalTax()
    {
      let temp = 0;
      if (this.shoppingDetail.orderGroups)
      {
        this.shoppingDetail.orderGroups.map((orderGroup) =>
        {
          orderGroup.orders.map((order) =>
          {
            if (order.needInvoice)
            {
              temp += order.tax;
            }
          });
        });
      }

      return temp;
    },
  },
  watch: {
    password(value)
    {
      if (value.length === 6)
      {
        this.$store.dispatch("app/showLoading");
        payByBalance({ billId: this.billId, password: value })
          .then((res) =>
          {
            this.$store.dispatch("app/hideLoading");
            Toast({
              message: res.data ? "支付成功" : "支付失败",
              position: "center",
              duration: 1000,
            });
            // 现在要到支付完成页面

            this.$router.replace({
              path: "/mine/order/payComplete",
              query: { active: 2, backRoute: "Mine" },
            });

            // //   // 这是订单中心
            // this.$router.replace({
            //   path: '/mine/order',
            //   query: { active: 2, backRoute: 'Mine' },
            // })
          })
          .catch((e) =>
          {
            this.password = "";

            this.$store.dispatch("app/hideLoading");
          });
      }
    },
  },
  beforeRouteUpdate(to, from, next)
  {
    console.log(to, from);
    if (
      from.name === "SettleAddressList"
      // from.name === "SettleAddressList" &&
      // this.$store.state.settle.currentAddress !== this.curAddressId
    )
    {
      console.log(
        "this.$store.state.settle.currentAddress",
        this.$store.state.settle.currentAddress
      );
      console.log("this.curAddressId", this.curAddressId);
      const currentAddress = this.$store.state.settle.currentAddress;
      this.currentAddress = currentAddress;
      getAddressList(this.$store.state.user.customerId)
        .then((addressRes) =>
        {
          this.updateAddress(addressRes);
        })
        .then(() =>
        {
          this.calcOrder();
          this.addressList.map((item) =>
          {
            if (currentAddress === item.id)
            {
              this.selectedAddress = item;
            }
          });
        });
    }
    if (to.name === "NeedInvoice")
    {
      this.showSubmitBar = false;
    }
    if (from.name === "NeedInvoice")
    {
      this.showSubmitBar = true;
      this.shoppingDetail.orderGroups.map((orderGroup) =>
      {
        if (orderGroup.actId === this.InvoicingActId)
        {
          orderGroup.orders.forEach((order) =>
          {
            if (order.signBrandId === this.InvoicingSignBrandId)
            {
              const invoice = this.$store.state.settle.invoice;
              order.needInvoice = invoice.setting.needInvoice;
              order.customerInvoiceId = invoice.setting.customerInvoiceId;

              if (invoice.setting.useDependenceInvoiceAddress)
              {
                order.useDependenceInvoiceAddress = true;
                order.name = invoice.currentInvoiceAddress.name;
                order.invoiceAddress = invoice.currentInvoiceAddress.name;
              } else
              {
                order.useDependenceInvoiceAddress = false;
              }

              return;
            }
          });
          return;
        }
      });
    }
    next();
  },
};
</script>

<style scoped>
.van-submit-bar__bar .van-submit-bar__text {
  padding-top: 0;
}
.wrapper {
  display: flex;
  align-items: center;
  justify-content: center;
  height: 100%;
}

.block {
  height: 280px;
  background-color: #fff;
}
</style>
